import { fetchClient } from '../../Utils/helpers';
import {
  ADD_REMINDER,
  ADD_TO_CART,
  ADD_TO_WATCHLIST,
  CANCEL_SELLING,
  CHECKOUT_ITEM,
  DELETE_FROM_CART,
  GET_AUCTION_FROM_MARKET,
  GET_CART,
  GET_FIXEDPRICE_FROM_MARKET,
  GET_ITEM_DETAILS,
  GET_ITEM_FROM_MARKET,
  GET_MARKET_MY_BID,
  GET_MARKET_MY_ORDERS,
  GET_MARKET_SALE_ITEM,
  GET_MARKET_WATCHLIST,
  GET_MY_ITEM_FROM_MARKET,
  GET_REQUESTED_ITEMS,
  GET_REQUESTED_ITEM_DETAILS,
  POST_ITEM_TO_MARKET,
  SELL_ITEM,
  UPDATE_REQUESTED_ITEM_STATUS,
} from '../actionTypes';

export function postItemToMarket(data) {
  return {
    type: POST_ITEM_TO_MARKET,
    payload: fetchClient({
      method: 'POST',
      url: '/admin/items',
      data,
    }),
  };
}

export function updateMarketItem(itemId, data) {
  return {
    type: POST_ITEM_TO_MARKET,
    payload: fetchClient({
      method: 'PUT',
      url: `/admin/item/${itemId}`,
      data,
    }),
  };
}

export function getItemList(uid) {
  return {
    type: GET_ITEM_FROM_MARKET,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}/items`,
    }).then((res) => res.data),
  };
}

export function getMyBid(uid = '', meta = {}) {
  const {
    limit = 10, page = 1, keyword = '', sort = '', sortprice = '', category = '',
  } = meta;
  return {
    type: GET_MARKET_MY_BID,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}/bid-items?limit=${limit}&page=${page}&keyword=${keyword}&sort=${sort}&sort_price=${sortprice}&category_id=${category}`,
    }).then((res) => res.data),
  };
}

export function getWatchlist(uid = '', meta = {}) {
  const {
    limit = 10, page = 1, keyword = '', sort = '', sortprice = '', category = '',
  } = meta;
  return {
    type: GET_MARKET_WATCHLIST,
    payload: fetchClient({
      method: 'GET',
      url: `/user-watchlist/${uid}?limit=${limit}&page=${page}&keyword=${keyword}&sort=${sort}&sort_price=${sortprice}&category_id=${category}`,
    }).then((res) => res.data),
  };
}

export function getMyOrders(uid = '', meta = {}) {
  const {
    limit = 10, page = 1, keyword = '', sort = '', sortprice = '', category = '',
  } = meta;
  return {
    type: GET_MARKET_MY_ORDERS,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}/order-items?limit=${limit}&page=${page}&keyword=${keyword}&sort=${sort}&sort_price=${sortprice}&category_id=${category}`,
    }).then((res) => res.data),
  };
}

export function getSaleItem(uid = '', meta = {}) {
  const {
    limit = 10, page = 1, keyword = '', sort = '', sortprice = '', category = '',
  } = meta;
  return {
    type: GET_MARKET_SALE_ITEM,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}/sale-items?limit=${limit}&page=${page}&keyword=${keyword}&sort=${sort}&sort_price=${sortprice}&category_id=${category}`,
    }).then((res) => res.data),
  };
}

export function getMarketItems(uid = '', meta = {}) {
  const {
    limit = 10, page = 1, keyword = '', saleType = '', sort = '', sortprice = '', category = '', activeTab = '',
  } = meta;
  let basePath = '/public/items';
  if (uid) {
    basePath = `/user/${uid}/items`;
  }
  return {
    type: GET_ITEM_FROM_MARKET,
    payload: fetchClient({
      method: 'GET',
      url: `${basePath}?limit=${limit}&page=${page}&keyword=${keyword}&sale_type=${saleType}&sort=${sort}&sort_price=${sortprice}&category_id=${category}&type=${activeTab}`,
    }).then((res) => res.data),
  };
}

export function getAuction(uid = '', meta = {}) {
  const { limit = 1, page = 1 } = meta;
  let basePath = '/public/items';
  if (uid) {
    basePath = `/user/${uid}/items`;
  }
  return {
    type: GET_AUCTION_FROM_MARKET,
    payload: fetchClient({
      method: 'GET',
      url: `${basePath}?limit=${limit}&page=${page}&sale_type=Auction&sort=asc`,
    }).then((res) => res.data),
  };
}

export function getFixedPrice(uid = '', meta = {}) {
  const { limit = 1, page = 1 } = meta;
  let basePath = '/public/items';
  if (uid) {
    basePath = `/user/${uid}/items`;
  }
  return {
    type: GET_FIXEDPRICE_FROM_MARKET,
    payload: fetchClient({
      method: 'GET',
      url: `${basePath}?limit=${limit}&page=${page}&sale_type=Fixed Price&sort=asc`,
    }).then((res) => res.data),
  };
}

export function getAdminItemList(query) {
  const { keyword = '', limit = 10, offset = 0 } = query;
  return {
    type: GET_MY_ITEM_FROM_MARKET,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/items/market?keyword=${keyword}&limit=${limit}&offset=${offset}`,
    }).then((res) => res.data),
  };
}

export function getItemDetails(uid, itemId, type = '') {
  return {
    type: GET_ITEM_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}/items/${itemId}?type=${type}`,
    }),
  };
}

export function getAdminItemDetails(itemId) {
  return {
    type: GET_ITEM_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/item/${itemId}`,
    }),
  };
}

export function getAdminMarketItemDetails(itemId, type = 'item') {
  return {
    type: GET_ITEM_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/market/${itemId}?type=${type}`,
    }),
  };
}

export function checkoutItem(uid, itemId) {
  return {
    type: CHECKOUT_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/user/items/${uid}/checkout/${itemId}`,
    }).then((res) => {
      window.location.href = res.data.data?.url;
      return res;
    }),
  };
}

export function checkoutItems(uid, data) {
  return {
    type: CHECKOUT_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/user/items/${uid}/checkout`,
      data,
    }).then((res) => {
      window.location.href = res.data.data?.url;
      return res;
    }),
  };
}

export function checkoutItemWinner(uid, itemId) {
  return {
    type: CHECKOUT_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/user/items/${uid}/checkout-winner/${itemId}`,
    }).then((res) => {
      window.location.href = res.data.data?.url;
      return res;
    }),
  };
}

export function sellItemToMarket(uid, itemId, data) {
  return {
    type: SELL_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/user/stored/${uid}/${itemId}`,
      data,
    }),
  };
}

export function sellMultiItemToMarket(uid, data) {
  return {
    type: SELL_ITEM,
    payload: fetchClient({
      method: 'POST',
      url: `/user/stored-multiple/${uid}`,
      data,
    }),
  };
}

export function getRequestedItems(query = {}) {
  const { page = 1, limit = 10, keyword = '' } = query;
  return {
    type: GET_REQUESTED_ITEMS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/find-items?page=${page}&limit=${limit}&keyword=${keyword}`,
    })
      .then((res) => res.data),
  };
}

export function getRequestedItemDetails(requestId) {
  return {
    type: GET_REQUESTED_ITEM_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/find-items/${requestId}`,
    }),
  };
}

export function updateRequestedItemStatus(requestId, data) {
  return {
    type: UPDATE_REQUESTED_ITEM_STATUS,
    payload: fetchClient({
      method: 'PATCH',
      url: `/admin/find-items/${requestId}`,
      data,
    }),
  };
}

export function addToCart(userId, data) {
  return {
    type: ADD_TO_CART,
    payload: fetchClient({
      method: 'POST',
      url: `/user-cart/${userId}`,
      data,
    }),
  };
}

export function deleteFormCart(userId, itemId) {
  return {
    type: DELETE_FROM_CART,
    payload: fetchClient({
      method: 'DELETE',
      url: `/user-cart/${userId}/${itemId}`,
    }).then(() => ({
      data: itemId,
    })),
  };
}

export function getCart(userId, data) {
  return {
    type: GET_CART,
    payload: fetchClient({
      method: 'GET',
      url: `/user-cart/${userId}`,
      data,
    }),
  };
}

export function addToWatchlist(userId, data) {
  return {
    type: ADD_TO_WATCHLIST,
    payload: fetchClient({
      method: 'POST',
      url: `/user-watchlist/${userId}`,
      data,
    }),
  };
}

export function addReminder(userId, data) {
  return {
    type: ADD_REMINDER,
    payload: fetchClient({
      method: 'POST',
      url: `/user-reminder/${userId}`,
      data,
    }),
  };
}

export function unsellProduct(userId, productId) {
  return {
    type: CANCEL_SELLING,
    payload: fetchClient({
      method: 'POST',
      url: `/user/unsell/${userId}/${productId}`,
    }),
  };
}
